import { Button } from '@/components/ui'
import { pagesReadOut, sentenceCase } from './moves'
import type { DocumentPage } from './types'

interface PickUpPanelProps {
  selectedPages: DocumentPage[]
  // True when the pages in hand are every page of one statement, so there is nothing to split off.
  alreadyOneStatement: boolean
  onMakeNewStatement: () => void
  onTakeOut: () => void
  onClear: () => void
}

const ALREADY_ONE_STATEMENT =
  'These pages are already one statement. Drop them on another account or month to move them.'

// Sits at the foot of the side column, so picking pages up never pushes the map or the strip.
export const PickUpPanel = ({
  selectedPages,
  alreadyOneStatement,
  onMakeNewStatement,
  onTakeOut,
  onClear,
}: PickUpPanelProps) => (
  <div
    data-pick-up-panel
    className="space-y-3 border-t-2 border-blue-500 bg-blue-50 p-4 text-[13px] leading-5"
  >
    <div className="space-y-1">
      <p className="font-medium text-blue-800">
        {sentenceCase(pagesReadOut(selectedPages))} picked up
      </p>
      <p className="text-blue-900/80">
        Drag them onto a month in the map or onto another statement's pages, or
        click a month. Escape clears.
      </p>
    </div>
    <div className="flex flex-col gap-2">
      {/* A disabled button takes no pointer, so the reason hangs on its wrapper. */}
      <span
        className="flex flex-col"
        title={alreadyOneStatement ? ALREADY_ONE_STATEMENT : undefined}
      >
        <Button
          theme="outline"
          disabled={alreadyOneStatement}
          onClick={onMakeNewStatement}
        >
          Make these a new statement
        </Button>
      </span>
      <div className="flex gap-2">
        {/* Taking every page out of a statement deletes it, so the button says so. */}
        <Button
          theme={alreadyOneStatement ? 'destructive' : 'outline'}
          className="flex-1"
          onClick={onTakeOut}
        >
          {alreadyOneStatement
            ? 'Delete this statement'
            : 'Take out of the statement'}
        </Button>
        <Button theme="ghost" onClick={onClear}>
          Clear
        </Button>
      </div>
    </div>
  </div>
)
